"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

var _api = _interopRequireDefault(require("../http/api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-check

/**
 * Generate the error ID
 *
 * @returns {string}
 */
var generateErrorId = function generateErrorId() {
  return new Date().getTime().toString(32).toUpperCase();
};
/**
 * Log an error message with the Zola logger in Admin
 *
 * @param {string} errorMessage General error message
 * @param {object} payload Any additonal info to pass to the logger. Will accept any JSON object
 * @returns {string}
 */


var log = function log(errorMessage, payload) {
  var errorId = generateErrorId();
  var errorMeta = {
    id: errorId,
    message: errorMessage
  };
  var body = {
    meta: errorMeta,
    data: payload
  }; // Don't wait for the response since there's not much we can do if it fails

  _api.default.post("/api/v0/log/".concat(errorId), body).catch(function () {
    return null;
  }); // Return the error id to display for the user in case they contact CS


  return errorId;
};

var _default = {
  log: log
};
exports.default = _default;